/**
 * Frontend JS
 */
class Bastille {
  constructor() {
    this.wistiaVideos();
    this.mainContent();
    this.hubspotEvents();
    //this.alertbar();
    this.gtm();
  }

  alertbar() {
    const $submenu = $(`header .top-bar .top-bar-right .is-dropdown-submenu`);
    const $mobileMenu = $(`#mobile-menu`);
    const $hamburger = $(`#hamburger`);
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    const $alertbar = $(`.alertbar`);

    let alertbarHeight = $alertbar.outerHeight(true);

    let initialDropdownOffset = $submenu.css("top").replace("px", "");
    initialDropdownOffset = parseInt(initialDropdownOffset, 10);

    let initialMobileMenuOffset = $mobileMenu.css("top").replace("px", "");
    initialMobileMenuOffset = parseInt(initialMobileMenuOffset, 10);

    let initialHamburgerOffset = $hamburger.css("top").replace("px", "");
    initialHamburgerOffset = parseInt(initialHamburgerOffset, 10);

    const calculate = (e) => {
      if ($alertbar.is(":visible")) {
        alertbarHeight = $alertbar.outerHeight(true);
        const mobileMenuOffset = alertbarHeight + initialMobileMenuOffset - 4;
        $mobileMenu.css("top", `${mobileMenuOffset}px`);
        const hamburgerOffset = alertbarHeight + initialHamburgerOffset;
        $hamburger.css("top", `${hamburgerOffset}px`);
        const submenuOffset = alertbarHeight + initialDropdownOffset;
        $submenu.css("top", `${submenuOffset}px`);
      } else {
        $mobileMenu.removeAttr("style");
        $hamburger.removeAttr("style");
        $submenu.removeAttr("style");
      }
    };

    calculate();
    mediaQuery.addEventListener("change", calculate);
  }

  gtm() {
    const hubspotutk = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
    const value = hubspotutk ? hubspotutk[1] : null;
    if (hubspotutk) {
      dataLayer.push({
        hubspotutk: value,
      });
    }
  }

  isValidJSON(str) {
    try {
      JSON.parse(str);
      return true; // The string is valid JSON
    } catch (e) {
      return false; // The string is not valid JSON
    }
  }

  // [data-hubspot-event='{ "name": "pe3894288_webinar_register", "properties": { } }']
  hubspotEvents() {
    $(window).on("load", (event) => {
      const $hubspotEvent = $("[data-hubspot-event]");
      if (!$hubspotEvent.length) return;

      if (typeof _hsq !== "object") {
        console.log(`Hubspot tracking script not loaded.`);
        return;
      }

      $hubspotEvent.on("click", (event) => {
        event.preventDefault();

        const $this = $(event.currentTarget);
        const href = $this.attr("href");
        const params = $this.data();

        if (this.isValidJSON(params) && Object.hasOwn(params, "name")) {
          console.log(`Tracking custom event in Hubspot`, params);
          _hsq.push([
            "trackCustomBehavioralEvent",
            {
              name: params.name,
              properties: params.properties || {},
            },
          ]);
        }

        if (href) {
          location.href = href;
        }
      });
    });
  }

  mainContent() {
    const $mainContent = $(`#main-content`);
    if (!$mainContent.length) return;

    // Empty paragraphs
    $mainContent.find("p:empty").remove();

    // Paragraphs with empty <canvas> elements
    $("p")
      .filter(function () {
        return $(this).children("canvas").length === 1 && $(this).children().length === 1 && $(this).children("canvas").is(":empty");
      })
      .remove();
  }

  wistiaVideos() {
    // Create an IntersectionObserver to detect when wistia links or containers are in viewport
    const revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // When elements are visible, initialize wistia videos
            initWistiaVideos();
            // Unobserve all targets after triggering once
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
        rootMargin: "100px", // Load a bit before they come into view
      }
    );

    // Find wistia links and containers to observe
    const $wistiaVideoLinks = $('a[href*="?wvideo="]');
    const $wistiaEmbeds = $("#wistia-container");

    // If neither exists, exit early
    if (!$wistiaVideoLinks.length && !$wistiaEmbeds.length) return;

    // Observe the first wistia link or container
    if ($wistiaVideoLinks.length) {
      revealObserver.observe($wistiaVideoLinks[0]);
    } else if ($wistiaEmbeds.length) {
      revealObserver.observe($wistiaEmbeds[0]);
    }

    // Wistia initialization function
    function initWistiaVideos() {
      // Load wistia global JS
      $("<script>", {
        src: "https://fast.wistia.com/assets/external/E-v1.js",
        async: true,
      }).appendTo("head");

      // Extract wistia video ID from URL
      const regex = /[^?]+\?wvideo=([a-z0-9]+)/gm;

      // Replace all instances found with proper Wistia embeds
      $wistiaVideoLinks.each((i, elem) => {
        const $link = $(elem);
        const href = $link.attr("href");

        // Extract video ID
        let videoId = regex.exec(href);
        if (!videoId || !videoId[1]) return;
        videoId = videoId[1];

        // Load Wistia video player
        const player = `<div id="wistia_${videoId}" class="wistia_embed wistia_async_${videoId} autoPlay=false
        controlsVisibleOnLoad=false"></div>`;
        $link.replaceWith(player);

        // Remove link to wistia video after player
        const $textLinks = $(`a[href*="?wvideo=${videoId}"]`);
        if ($textLinks.length) {
          $textLinks.parent("p").remove();
        }

        $("<script>", {
          src: `https://fast.wistia.com/embed/medias/${videoId}.jsonp`,
          async: true,
        }).appendTo("head");
      });
    }
  }
}

new Bastille();
